import { gql } from '@apollo/client';

export const GET_LE_GROUP_FOR_FIRST_FITTING = gql`
  query GetLEGroupForFirstFitting {
    profile {
      groupLECodeForFirstFitting
    }
  }
`;
